import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { SelectButtonModule } from 'primeng/selectbutton';

import { SharedModule } from '@app/shared';
import { DisplayBadgeModule } from '@app/shared/display-badge/display-badge.module';
import { DisplayCityStateModule } from '@app/shared/display-city-state/display-city-state.module';
import { FeaturedJobsModule } from '@app/shared/featured-jobs/featured-jobs.module';
import { JobLoadingModule } from '@app/shared/job-loading/job-loading.module';
import { JobPropertiesModule } from '@app/shared/job-properties/job-properties.module';
import { JobsService } from '@app/shared/jobs.service';
import { SearchModule } from '@app/shared/search/search.module';
import { JobsRoutingModule } from './jobs-routing.module';
import { JobsComponent } from './jobs.component';

@NgModule({
  declarations: [JobsComponent],
  exports: [],
  imports: [
    CommonModule,
    DisplayBadgeModule,
    DisplayCityStateModule,
    FeaturedJobsModule,
    FormsModule,
    JobLoadingModule,
    JobPropertiesModule,
    MultiSelectModule,
    NgxSkeletonLoaderModule,
    PanelModule,
    SearchModule,
    SelectButtonModule,
    SharedModule,
    JobsRoutingModule,
  ],
  providers: [JobsService],
})
export class JobsModule {}
